/**
 * Escala por número de jogadores (F71, doc 09 §4, item 8). Sozinho: a ultimate carrega 30 % mais rápido e
 * o dano das criaturas cai 15 % (o Elo menor da F67 também é só do solo). No "juntar" dos chefes, a área
 * pede metade do grupo vivo (arredondada para cima); com menos gente, o dano dividido pesa 50 % a mais.
 * Na Arena (Treta), os bônus de combate das classes valem a metade.
 */
export const COOP = { soloCharge: 1.3, soloDamageTaken: 0.85, shareShortMul: 1.5, arenaClassScale: 0.5 } as const;

/** Quantos o "juntar" pede com `alive` jogadores vivos. */
export const shareNeed = (alive: number): number => Math.max(1, Math.ceil(alive / 2));
